// fancy_cart.js – cart helpers for combo/fancy add-to-cart (add products via API, update cart UI)
// Load before fancy_cart_2026.js when using cooler/combo product templates

// ********************************************* //
// COMBO PRICE CALCULATOR                        //
// config: { basePriceSelector, priceDisplaySelector, formSelector, addons[], stickyPriceSelector? }
// addon: { pickerClass, optionSelector, included, flatExtraPrice?, optionValueIsQuantity? }
//   - flatExtraPrice (cents): extra units charged at this rate; units = selected option count
//   - optionValueIsQuantity: false for single-select (e.g. deposit) where option value = variant id; then qty = 1
//   - else: extra cost from each option's data('price') * qty over included
// ********************************************* //

function initComboPrice(config) {
	var basePriceSelector = config.basePriceSelector || '#product-select-pid';
	var priceDisplaySelector = config.priceDisplaySelector || '#ProductPrice';
	var formSelector = config.formSelector || 'form';
	var addons = config.addons || [];
	var stickyPriceSelector = config.stickyPriceSelector || '#sticky-price';

	function computeAddonCost(form, addon, addonIndex) {
		var fullSelector = addon.pickerClass + ' ' + addon.optionSelector;
		var options = form.find(fullSelector);
		var included = addon.included != null ? addon.included : 0;
		var regularCost = 0;
		var depositCost = 0;

		if (addon.flatExtraPrice != null) {
			var count = options.length;
			var extra = Math.max(0, count - included);
			regularCost = extra * addon.flatExtraPrice;
			if (window.console && console.log) {
				console.log('[ComboPrice] addon ' + addonIndex + ' (flat) picker=' + addon.pickerClass + ' | options.length=' + count + ' included=' + included + ' extra=' + extra + ' cost=' + regularCost + '¢');
			}
			return { regular: regularCost, deposit: 0 };
		}

		var processed = 0;
		var useOptionValueAsQty = addon.optionValueIsQuantity !== false; // false for single-select (e.g. deposit) where value = variant id
		// Sanity caps: option value can be variant id (huge); data-price must be cents, not variant id
		var MAX_REASONABLE_QTY = 1000;
		var MAX_REASONABLE_PRICE_CENTS = 1e9; // $10M
		if (window.console && console.log) {
			console.log('[ComboPrice] addon ' + addonIndex + ' (per-option) picker=' + addon.pickerClass + ' | selector=' + fullSelector + ' | options.length=' + options.length + ' included=' + included + ' useOptionValueAsQty=' + useOptionValueAsQty);
		}
		options.each(function(idx) {
			var rawVal = $(this).val();
			var rawPrice = $(this).data('price');
			var qty = useOptionValueAsQty ? (parseInt(rawVal, 10) || 0) : 1;
			if (qty > MAX_REASONABLE_QTY) { qty = 1; } // option value is likely variant id, not quantity
			var price = parseInt(rawPrice, 10) || 0;
			if (price > MAX_REASONABLE_PRICE_CENTS) { price = 0; } // avoid using variant id as price
			
			var addedCost = 0;
			if (processed + qty <= included) {
				processed += qty;
			} else if (processed >= included) {
				addedCost = qty * price;
				processed += qty;
			} else {
				var split = included - processed;
				var remainder = qty - split;
				addedCost = remainder * price;
				processed += qty;
			}

			// Check if this option is a deposit (either by product name or picker class)
			var productName = ($(this).data('productname') || '').toLowerCase();
			var isDeposit = productName.indexOf('deposit') > -1 || (addon.pickerClass && addon.pickerClass.toLowerCase().indexOf('deposit') > -1);

			if (isDeposit) {
				depositCost += addedCost;
			} else {
				regularCost += addedCost;
			}

			if (window.console && console.log) {
				console.log('[ComboPrice]   option[' + idx + '] val="' + rawVal + '" data(price)="' + rawPrice + '" → qty=' + qty + ' price=' + price + '¢ addedCost=' + addedCost + ' (isDeposit: ' + isDeposit + ')');
			}
		});
		if (window.console && console.log && options.length) {
			console.log('[ComboPrice] addon ' + addonIndex + ' total regular=' + regularCost + '¢, deposit=' + depositCost + '¢');
		}
		return { regular: regularCost, deposit: depositCost };
	}

	function updatePrice() {
		var form = $(formSelector);
		var baseEl = $(basePriceSelector);
		if (baseEl.is('select')) {
			baseEl = baseEl.find('option:selected');
		}
		var baseFromData = baseEl.data('price');
		var baseFromAttr = baseEl.attr('data-price');
		var baseCents = parseInt(baseFromData, 10) || parseInt(baseFromAttr, 10) || 0;
		// If base looks like a variant id (huge), prefer attribute (initial HTML value)
		if (baseCents > 1e9) {
			baseCents = parseInt(baseFromAttr, 10) || 0;
			if (window.console && console.warn) {
				console.warn('[ComboPrice] base price from .data() was huge (' + baseFromData + '), using .attr("data-price")=' + baseFromAttr + ' → baseCents=' + baseCents);
			}
		}
		if (window.console && console.log) {
			console.log('[ComboPrice] updatePrice() base: selector=' + basePriceSelector + ' .data(price)=' + baseFromData + ' .attr(data-price)=' + baseFromAttr + ' → baseCents=' + baseCents);
		}
		
		var totalRegularCents = baseCents;
		var totalDepositCents = 0;

		for (var i = 0; i < addons.length; i++) {
			var addonCosts = computeAddonCost(form, addons[i], i);
			totalRegularCents += addonCosts.regular;
			totalDepositCents += addonCosts.deposit;
		}

		var displayRegular = (totalRegularCents / 100).toFixed(2);
		var displayString = '$' + displayRegular;
		var htmlString = displayString;
		
		if (totalDepositCents > 0) {
			var displayDeposit = (totalDepositCents / 100).toFixed(2);
			displayString += ' + $' + displayDeposit + ' deposit';
			htmlString += ' <span class="deposit-price">+ $' + displayDeposit + ' deposit</span>';
		}

		$(priceDisplaySelector).html(htmlString);
		if (window.console && console.log) {
			console.log('[ComboPrice] totalRegular=' + totalRegularCents + ' totalDeposit=' + totalDepositCents + ' display="' + displayString + '"');
		}
	}

	// Initial price calculation
	updatePrice();

	// On form change
	$(formSelector).on('change', updatePrice);

	// Sticky price on scroll
	if ($(stickyPriceSelector).length) {
		var priceTop = $(stickyPriceSelector).offset().top;
		$(window).on('scroll', function() {
			if ($(window).scrollTop() > priceTop) {
				$(stickyPriceSelector).addClass('sticky-sticky-price');
			} else {
				$(stickyPriceSelector).removeClass('sticky-sticky-price');
			}
		});
	}
}

// ********************************************* //
// ADD PRODUCTS (SERIALIZED)                     //
// ********************************************* //

function addProductsSerialized(products){
	console.log('addProductsSerialized() PRODUCT:');
	console.log(products);

	fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(products)
	})
	.then(response => {
		if (!response.ok) {
			return response.json().then(err => { throw err; });
		}
		return response.json();
	})
	.then(data => {
		console.log('Items added to cart:', data);
		updateCartCount();
	})
	.catch(error => {
		console.error('Error adding items to cart:', error);
		if (error && error.description) {
			//Remove processing spinner
			$('#cart-spinner').fadeOut(200, function(){
				$('#AddToCartText').text('Add to cart!');  
			});	
			alert('Error: ' + error.description);
	
			resetAddToCartButton();
		} else if (error && error.message) {
			//Remove processing spinner
			$('#cart-spinner').fadeOut(200, function(){
				$('#AddToCartText').text('Add to cart!');  
			});	
			alert('Error: ' + error.message);
			
			resetAddToCartButton();
		}
	});
}

// ********************************************* //
// UPDATE CART COUNT                             //
// ********************************************* //

function updateCartCount(){
	$.ajax({
		type: 'GET',
		url: '/cart.js',
		async: true,
		dataType: 'json',
		error: function(){},
		success: function(cart){
			const cart_button_text = 'Add To Cart!';
			$('#cart-spinner').fadeOut(50);
			$('#add-to-cart-combo').prop('disabled', false);
			$('#cart-counter').text(cart.item_count).removeClass('hidden-count');
			$('#AddToCartText').fadeOut(50, function(){
				$('#AddToCartText').text('Added to cart!').fadeIn(50,function(){
					$('#AddToCartText').delay(2000).fadeOut(50, function(){
						$('#AddToCartText').text(cart_button_text).fadeIn(50);
					});
				});
			});	
		},
		cache: false
	});
}

function resetAddToCartButton(){
	const cart_button_text = 'Add To Cart!';
	$('#cart-spinner').fadeOut(50, function(){
			$('#AddToCartText').text(cart_button_text).fadeIn(50);
			$('AddToCartText').fadeIn(50);
	});
	$('#add-to-cart-combo').prop('disabled', false);
}
